var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnSoundOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1943 16.6943C21.3358 14.9604 22 12.8845 22 10.6535C22 5.52808 18.4945 1.22114 13.75 0V2.54951C17.1257 3.69479 19.5551 6.89026 19.5551 10.6535C19.5551 12.2064 19.1414 13.6627 18.4181 14.9181L20.1943 16.6943ZM18.939 18.2674L17.2099 16.5383C16.2641 17.536 15.0806 18.306 13.75 18.7574V21.3069C15.7593 20.7898 17.5463 19.7192 18.939 18.2674ZM15.0498 14.3782C14.6729 14.7874 14.2348 15.1393 13.75 15.4194V13.0784L15.0498 14.3782ZM11 10.3284V19.8197L4.58333 14.3197H0V6.98633H4.58333L6.23887 5.5673L11 10.3284ZM13.75 10.25L16.1351 12.6351C16.3727 12.0203 16.503 11.3521 16.503 10.6535C16.503 8.61646 15.3956 6.8381 13.75 5.88754V10.25ZM11 7.5L7.76187 4.26187L11 1.48633V7.5Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 27.0006,
    height: 2,
    transform: "rotate(45 2 1)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnSoundOff);
export default __webpack_public_path__ + "static/media/btn_sound_off.bf5d4745c86a43f8f96ed6911db61696.svg";
export { ForwardRef as ReactComponent };